// extracted by mini-css-extract-plugin
export var button = "partner-code-tile-module--button--2213d";
export var buttons = "partner-code-tile-module--buttons--d5687";
export var rightButtonsWrapper = "partner-code-tile-module--right-buttons-wrapper--6aff9";
export var termButton = "partner-code-tile-module--term-button--bac9d";